export const basicCmsEmail = `
<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html>
  <head>
  <meta name="viewport" content="width=device-width" />
  <meta http-equiv="Content-Type" content="text/html charset=UTF-8" />
  <title>COIN - Compensation Benefits</title>
  <style type="text/css">
    .video\\0{ display: none; }
    .videoFallback\\0{ display: block !important; }
  </style>
  <!--[if (gte mso 9)|(IE)]>
  <style type="text/css">
  table {
  border-collapse: collapse;
  border-spacing: 0;
  outline: none;
  mso-table-lspace: 0pt !important;
  mso-table-rspace: 0pt !important;
 }
  </style>
  <![endif]-->
  </head>
  <body style="margin: 0; padding: 0;">
    <table id="$|TEMPLATE_ID|" class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100.0%;background:#F8F8F8;border-collapse:collapse">
      <tbody>
        <tr>
          <td style="padding:0cm 0cm 0cm 0cm">
            <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
              <tr>
                <td>
                  <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
                  <tr>
                    <td align="center">
                        <table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="600" style="width: 100%; max-width:450.0pt; background:white; border-collapse:collapse; margin: 0 auto;">
                          <tbody>
                            <tr>
                              <td style="padding:0cm 0cm 0cm 0cm">
                              <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
                                <tr>
                                  <td style="padding-top: 16px; padding-bottom: 16px; padding-left: 30px; padding-right: 30px; display: block; background-color: #1B1534;">
                                    $|HEADER_LOGO|
                                  </td>
                                </tr>
                              </table>
                              <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
                                <tr>
                                  <td style="padding-top: 16px; padding-bottom: 16px; padding-left: 30px; padding-right: 30px; display: block; background-color: #1B1534;">
                                    <p style="color: white; line-height: 15pt; font-size: 11pt;"><span style="font-family: Arial, Calibri, sans-serif;">$|DATE_TEXT|</span></p>
                                  </td>
                                </tr>
                              </table>
                              <div id="$|HEADLINE_CONTAINER_ID|">
                                <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
                                  <tr>
                                    <td width="600" style="line-height: 0px;">
                                      <img alt="header-image" width="600" style="line-height: 0px; width: 600px; max-width: 600px; vertical-align: bottom;" src="$|EMAIL_IMAGE|">
                                    </td>
                                  </tr>
                                </table>
                                <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
                                  <tr>
                                  $|MAIN_HEADLINE|
                                </tr>
                                </table>
                              </div>
                              <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
                                <tr>
                                  <td style="display: block; font-family: Arial, Calibri, sans-serif; line-height: 15pt; font-size: 11pt;">
                                    $|EMAIL_CONTENT|
                                  </td>
                                </tr>
                              </table>
                              <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
                                <tr>
                                  <td style="padding-top: 16px; padding-bottom: 16px; display: block; font-family: Arial, Calibri, sans-serif; line-height: 11pt; font-size: 11pt; background-color: #1B1534;">
                                    $|FOOTER_CONTENT|
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
        </table>
      </td>
    </tr>
  </tbody>
</table>
</body>
</html>`;
